<template>
  <!-- 投入品日销售明细·二级页面 -->
  <div style="margin-top: 10px; border-top: 1px solid rgb(125, 243, 164)">
    <div class="div" ref="logo_font">
      <div class="table_border">
        <div v-show="DataMonth" class="monthBox">
          <p>当月数据未更新</p>
        </div>
        <table
          class="table_cont"
          border="1"
          cellpadding="0"
          v-show="!DataMonth"
        >
        <thead>
          <tr
            style="
              color: #1eeabe;
              opacity: 0.69;
              background: #39819a;
              border: 1px solid #3a6c83;
            "
          >
            <td style="width:15%">店铺名称</td>
            <td style="width:10%">通用名</td>
            <td style="width:10%">商品名称</td>
            <td style="width:10%">商品类型</td>
            <td style="width:10%">规格</td>
            <td style="width:20%">追溯码</td>
            <td style="width:15%">交易日期</td>
            <td style="width:10%">售出量</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableList" :key="index">
            <td style="width:15%">{{ item.companyName }}</td>
            <td style="width:10%">{{ item.genericName }}</td>
            <td style="width:10%">{{ item.productName }}</td>
            <td style="width:10%">{{ item.productType  }}</td>
            <td style="width:10%">{{ item.productStand}}</td>
            <td style="width:20%">{{ item.traceCode }}</td>
            <td style="width:15%">{{ item.sellDate }}</td>
            <td style="width:10%">{{ item.sellNumber }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "digital_government",
  props:["inputType","sellDate"],
  data() {
    return {
      DataMonth: false,
      months: "",
      logo_font: require("@/assets/images/蒙版组 18.png"),
      logo_i: require("@/assets/images/路径 28799.png"),
      tableList: [],
      Data_txt: "",
    };
  },
  methods: {
    // 对应月份换数据
    getMonth() {
      var months = plOtherDataInterface.getSellInfoByDateAndInputTypeList(
       this.inputType,this.sellDate
      );
      // 为空显示暂无数据
      if (months.length == 0) {
        this.DataMonth = true;
      } else {
        this.tableList = months;
        this.DataMonth = false;
      }
    },
    skMonthrangeDefault() {
      let date = {
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
      };
      this.months = date.year + "-" + date.month;
    },
  },
  mounted() {
    this.skMonthrangeDefault();
    this.getMonth();
  },
};
</script>

<style lang="less" scoped>
.div {
  margin-top: 30px;
  background: #104853;
}
.logo_img {
  width: 6.25rem;
  height: 1.575rem;
  margin-top: 1.25rem;
}
.logo_icon {
  position: absolute;
  right: 0.625rem;
  top: 1.25rem;
  width: 1.0625rem;
  height: 1.0625rem;
  cursor: pointer;
}
.logo_font {
  padding-bottom: 1.875rem;
  position: relative;
  border-bottom: 1px solid rgb(125, 243, 164);
}
.table_border {
  overflow: auto;
  padding: 20px 20px 5px;
  height: 300px;
  background: #104853;
}
.border_height {
  padding: 35px 20px 10px;
}
.table {
  background: #104853;
  color: rgb(125, 243, 164);
  font-size: 1.2rem;
  width: 100%;
  text-align: center;
}
table tbody {
    display: block;
    max-height: 300px;            
    overflow-y: auto;
}
table thead,
tbody tr {
    display: table;
    table-layout: fixed; /* 使用表格固定算法 必须配合上面一起使用 */
    width: 100%;
    text-align: center; 
}
.table_cont {
  color: #fff;
  font-size: 16px;
  border-color: #83aabe;
     border-collapse: collapse;
  td {
    padding: 10px 0;
  }
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
::-webkit-scrollbar {
  background-color: #15606e;
  width: 5px;
} /* 这是针对缺省样式 (必须的) */
::-webkit-scrollbar-thumb {
  background: #00574a;
  width: 5px;
  border-radius: 10px;
} /* 滑块颜色 */
.monthBox {
  width: 100%;
  text-align: center;
  p {
    font-size: 30px;
    color: #fff;
  }
}
.demonstration {
  color: #fff;
  font-size: 17px;
}
/deep/.block {
  margin-top: 15px;
  text-align: right;
  padding-right: 25px;
}
/deep/.el-date-editor.el-input {
  width: 130px;
}
/deep/.el-input__inner {
  height: 27px;
  background: #39819a;
  color: #fff;
  border: 1px solid #39819a;
  cursor: pointer;
}
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 22px;
}
/deep/.el-input__icon {
  line-height: 27px;
}
/deep/.el-picker-panel {
  background-color: #15606e !important;
  left: 1111px !important;
}
/deep/.el-month-table td .cell {
  color: #fff !important;
}
/deep/.el-picker-panel__icon-btn,
.el-date-picker__header-label {
  color: #fff !important;
}
.selecticon {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/leftAside/detail_quality/productSales.vue